var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6 7 C 3.077 7 0.7394375 9.5082344 1.0234375 12.490234 C 1.2714375 15.090234 3.6028438 17 6.2148438 17 L 9 17 C 9.552 17 10 16.552 10 16 C 10 15.448 9.552 15 9 15 L 6.1699219 15 C 4.5459219 15 3.0898594 13.783156 3.0058594 12.160156 C 2.9148594 10.430156 4.29 9 6 9 L 9 9 C 9.552 9 10 8.552 10 8 C 10 7.448 9.552 7 9 7 L 6 7 z M 15 7 C 14.448 7 14 7.448 14 8 C 14 8.552 14.448 9 15 9 L 17.830078 9 C 19.454078 9 20.910141 10.216844 20.994141 11.839844 C 21.085141 13.569844 19.71 15 18 15 L 15 15 C 14.448 15 14 15.448 14 16 C 14 16.552 14.448 17 15 17 L 18 17 C 20.923 17 23.260563 14.491766 22.976562 11.509766 C 22.728562 8.9097656 20.397156 7 17.785156 7 L 15 7 z M 8 11 C 7.448 11 7 11.448 7 12 C 7 12.552 7.448 13 8 13 L 16 13 C 16.552 13 17 12.552 17 12 C 17 11.448 16.552 11 16 11 L 8 11 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/ShareLink.7b4bfcd2b6f017a5a6e801b25a5cd51e.svg";
export { ForwardRef as ReactComponent };